<template>
  <div class="login container">
    <div v-if="!redeemCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="submit">

      <div class="d-flex justify-content-between">
      <div class="col-xs-6 pl-3 pt-5">
        <cta link="redeem-amount" shape="circle" icon="left-arrow" text="" margin="no-margin" />
      </div>
      </div>

      <div class="row">
        <h2 class="col-md-12 pt-2">Confirm redemption</h2>
      </div>
      <div class="row">
        <p class="col-md-12 d-flex justify-content-center pt-2">Current card balance</p>
      </div>
      <div class="row">
        <h1 class="col-md-12 pt-2">{{getPriceDisplay(card.Currency,card.balance)}}</h1>
      </div>

      <div class="row d-flex justify-content-center pt-2">
        <p class="col-md-12 pt-2">Redemption amount</p>
      </div>
      <div class="row d-flex justify-content-center">
        <h1 class="col-md-12 pt-2">{{getPriceDisplay(card.Currency,redemptionAmount)}}</h1>
      </div>
      <div class="row d-flex justify-content-center pt-2">
        <p class="col-md-12 pt-2">New card balance</p>
      </div>
      <div class="row d-flex justify-content-center">
        <h1 class="col-md-12 pt-2">{{getPriceDisplay(card.Currency,newCardBalance)}}</h1>
      </div>
      <div class="row d-flex justify-content-center pt-4 pb-4">
        <cta type="submit" text="Confirm redemption" icon="right-arrow"  :loading="submitted" />
      </div>


    </form>
   
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        submitted:false
      };
  },
  computed: {
    // balance after redemption
    newCardBalance()
    {
      return this.card.balance - this.redemptionAmount;
    },
    card()
    {
        return this.$store.getters.getCard;
    },

    account(){
      return this.$store.getters.getAccount;
    },

    redemptionAmount()
    {
        return this.$store.getters.getRedemptionAmount;
    },

    unitId(){
      return this.$store.getters.getUnit.id;
    },

    accountCurrency(){
      return this.$store.getters.getAccountCurrency;
    }
  },
  methods:{

      /*
      * Login form submit handler
      */
      submit()
      {

        this.submitted = true;

        var variables = {
            currency      : this.accountCurrency.iso_currency_code,
            value         : -this.redemptionAmount,
            card_reference: this.card.card_reference,
            unit_id       : this.unitId,
            account_id       : this.account.id,
            restrict_pos_units: true
        }

    
        window.axios({
          url: process.env.VUE_APP_API_GRAPH_URL,
          method: 'post',
          data: {
            query: `
                mutation($currency:String,$value:Int,$card_reference:String, $unit_id:Int!, $account_id:Int!, $restrict_pos_units:Boolean) {
                    createBalanceAdjustment(
                        currency      : $currency,
                        card_reference: $card_reference,
                        value         : $value,
                        unit_id       : $unit_id,
                        account_id       : $account_id,
                        restrict_pos_units: $restrict_pos_units
                    ) 
                    {id}
                }
                `,
                variables:variables
          }
        }).then((result) => {

            var  api_errors_to_component_errors = {};

            if(this.validateGraphResponse(result,api_errors_to_component_errors)) {
              this.$store.commit('RESET_REDEEM_JOURNEY');
              this.$router.push({ name: 'redeemed'});
            } else {
              //Validation error
              if(result.data.errors && result.data.errors.length){
                  for (var i = 0, len = result.data.errors.length; i < len; i++) {
                      if(result.data.errors[i].message == "validation"){
                          for (var index in result.data.errors[i].validation) 
                              this.$bus.$emit('error_message', result.data.errors[i].validation[index][0]);
                      }
                  }
              } else {
                this.$bus.$emit('error_message', 'Something went wrong, please try again!');
              }
            }

        }).catch(() => {
            this.$bus.$emit('error_message', 'Something went wrong, please try again!');
        }).then(() => {
            this.submitted = false;
        })
          
      },
  }
}
</script>

<style scoped>

.cta_left{
  position: absolute;
  top:100px;
}

p{
  margin-bottom: 0;
}
h1{
  margin-top:0;
}

</style>
